import DBOperationsComb from "src/utils/dbOperationsComb";
import Exception from "src/utils/exception";

async function getAction(tableName, config) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName,
        ...config
      },
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  getAction
};
